const $$splitComponentImporter = () => import('/home/runner/work/inspecttec-frontend-admin/inspecttec-frontend-admin/src/routes/agencies/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { Permissions } from "@/constants/permissions";
import { requirePermission } from "@/lib/auth/permission-guard";
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/agencies/")({
  beforeLoad: args => requirePermission(Permissions.Agencies.ViewAll, args),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});